// §4.4 partial — wildcard catch-all for unrecognised URLs.
// Must be last in the composed route list; composer sorts partials
// alphabetically so _404 sorts before any feature but after all specifics
// because the router matches in definition order and this uses path: '*'.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const NotFoundPage = lazyWithRetry(() => import("./pages/NotFoundPage"));

const routes: RouteObject[] = [{ path: "*", Component: NotFoundPage }];

export default routes;
